import { WochenplanungPage } from './features/social/WochenplanungPage';
import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { initPostHog } from './lib/posthog';
import { AppShell } from './components/AppShell';
import { HomePage } from './features/home/HomePage';
import { LoginPage } from './features/auth/LoginPage';
import { EnrollMfaPage } from './features/auth/EnrollMfaPage';
import { ProtectedRoute } from './features/auth/ProtectedRoute';
import { HealthPage } from './features/health/HealthPage';
import { UserListPage } from './features/users/UserListPage';
import { UserDetailPage } from './features/users/UserDetailPage';
import { FeedbackInboxPage } from './features/feedback/FeedbackInboxPage';
import { FeedbackAnalysisPage } from './features/feedback/FeedbackAnalysisPage';
import { AnnouncementsPage } from './features/announcements/AnnouncementsPage';
import { ArticlesPage } from './features/articles/ArticlesPage';
import { AnalyticsPage } from './features/analytics/AnalyticsPage';
import { AiConversationsPage } from './features/aiConversations/AiConversationsPage';
import { ServicesPage } from './features/services/ServicesPage';
import { CampaignsPage } from './features/campaigns/CampaignsPage';
import { BroadcastsPage } from './features/broadcasts/BroadcastsPage';
import { AuditLogPage } from './features/audit/AuditLogPage';
import { KalenderPage } from './features/social/KalenderPage';
import { PipelineOverviewPage } from './features/pipelines/PipelineOverviewPage';
import { PipelineDetailPage } from './features/pipelines/PipelineDetailPage';
import { PresentationPage } from './features/pipelines/PresentationPage';
import { PostCockpitPage } from './features/social/PostCockpitPage';
import { ReviewDraftPage } from './features/social/ReviewDraftPage';
import { BestandPage } from './features/social/BestandPage';
import { RhythmenPage } from './features/social/RhythmenPage';
import { SocialErrorBoundary } from './features/social/SocialErrorBoundary';

export function App(): JSX.Element {
  useEffect(() => {
    initPostHog();
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Praesentationsmodus steht bewusst AUSSERHALB der AppShell: die
          Seitenleiste zeigt die E-Mail des Kontos und Links zu Nutzerdaten —
          nichts davon gehoert ins Bild, wenn ein Gast zuschaut. Der Schutz
          bleibt, nur der Rahmen faellt weg. */}
      <Route
        path="/present/pipelines/:slug"
        element={
          <ProtectedRoute>
            <PresentationPage />
          </ProtectedRoute>
        }
      />
      <Route path="/enroll-mfa" element={<EnrollMfaPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="users" element={<UserListPage />} />
        <Route path="users/:id" element={<UserDetailPage />} />
        <Route path="feedback" element={<FeedbackInboxPage />} />
        <Route path="feedback/auswertung" element={<FeedbackAnalysisPage />} />
        <Route path="announcements" element={<AnnouncementsPage />} />
        <Route path="articles" element={<ArticlesPage />} />
        <Route path="campaigns" element={<CampaignsPage />} />
        <Route path="broadcasts" element={<BroadcastsPage />} />
        {/* Die Boundary umschliesst JEDE Social-Route einzeln. Als gemeinsames
            Layout-Element waere sie eleganter, aber dann faengt sie auch die
            Fehler des Layouts selbst — und ein Fehler IM Auffangnetz reisst
            wieder die ganze Anwendung mit. */}
        <Route path="social" element={<SocialErrorBoundary><KalenderPage /></SocialErrorBoundary>} />
        <Route path="social/week" element={<SocialErrorBoundary><WochenplanungPage /></SocialErrorBoundary>} />
        <Route path="social/assets" element={<SocialErrorBoundary><BestandPage /></SocialErrorBoundary>} />
        <Route path="social/rhythmen" element={<SocialErrorBoundary><RhythmenPage /></SocialErrorBoundary>} />
        <Route path="social/post/:id" element={<SocialErrorBoundary><PostCockpitPage /></SocialErrorBoundary>} />
        <Route path="social/review/new" element={<SocialErrorBoundary><ReviewDraftPage /></SocialErrorBoundary>} />
        <Route path="pipelines" element={<PipelineOverviewPage />} />
        <Route path="pipelines/:slug" element={<PipelineDetailPage />} />
        <Route path="health" element={<HealthPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="audit" element={<AuditLogPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="ai-conversations" element={<AiConversationsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
